<template lang="pug">
app-page-layout
  div.detail-container.abs-fit
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="false" :style="{'min-width': '1600px'}") 
      div.create-order.flex(style="gap: 16px;")
        a-card.mt1(title="商家下单信息" :hoverable="false" style="flex: 1; background: #f2f2f5;")
          VendorDetail(:target="model")
        a-card.vender_detail_container.mt1(title="仓库订单信息" hoverable style="flex: 2")
          div.title 制单状态
          a-row(:gutter="16")
            a-col(:sm="12")    
              a-form-model-item(label="制单状态" prop="isMarkOrder" )
                div.p1 {{ model.isMarkOrder ? '已制单' : '未制单' }}
          div.title 出入库类型
          a-row(:gutter="16")
            a-col(:sm="12")    
              a-form-model-item(label="出入库" prop="stockType" )
                div.p1
                  app-dict-display(:value="model.stockType")
            a-col(:sm="12")    
              a-form-model-item(label="出入库子类" prop="stockSubType" )                
                div.p1
                  app-dict-display(:value="model.stockSubType")

              
            
            a-col(:sm="24")  
              a-form-model-item(label="出入库时间" prop="stockTime" )
                div.p1 {{ model.stockTime || '--' }}           
            
            a-col(:sm="24")  
              a-form-model-item(label="接单员备注" prop="takerComments" )
                div.p1 {{ model.takerComments || '--' }}
            
            
          div.title 车辆信息
          a-row(:gutter="16")              
            a-col(:sm="24") 
              a-form-model-item(label="" prop="carArranged" )
                CarRecordDTOS(v-model="model.carRecordDTOS" detailMode)
                //- a-input(v-model="model.carArranged" allow-clear :min="0" placeholder="请输入已配车辆")
                
            a-col(:sm="24")  
              a-form-model-item(label="调度员备注" prop="schedulerComments" )
                div.p1 {{ model.schedulerComments || '--' }}

          div.title.flex 产品出入库列表
          a-row(:gutter="16") 
            a-col(:sm="24")  
              a-form-model-item(label="" prop="keeperComments" )
                ProductDTOS(:productDTOS="model.orderItems" :target.sync="model" detailMode)
            
            a-col(:sm="24")  
              a-form-model-item(label="库管备注" prop="keeperComments" )
                div.p1 {{ model.keeperComments || '--' }}
          
          div.title(
            v-if="['orderSubType_send', 'orderSubType_selfExtraction', 'orderSubType_express'].includes(model.stockSubType)"
          ) 物流信息
          
            a-form-model-item(label="物流备注")
              div.p1 {{ model.logisticsComments || '--' }}
  Actions(:target="model" @reload="loadModel" )
</template>

<script>
import VendorDetail from './Components/VendorDetail/index';
import ProductDTOS from './Modal/ProductDTOSDetail';
import CarRecordDTOS from './Modal/CarRecordDTOSDetail';
import Actions from './Components/Actions/detail';

import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'detailXXX',
  components: {
    VendorDetail,
    ProductDTOS,
    CarRecordDTOS,
    Actions,
  },
  data() {
    return {
      activeTabKey: 'vendor',
      tabList: [
        { key: 'vendor', tab: '商家信息' },
        { key: 'cars', tab: '车辆信息' },
        { key: 'inventories', tab: '出入库信息' },
      ],
      fields: [
        {
          name: 'vendorId',
          label: '商家ID',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'orderType',
          label: '订单类型',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'orderSubType',
          label: '订单子类型',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'feeMode',
          label: '收费模式',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'amount',
          label: '订单金额',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'serviceFee',
          label: '服务费用',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'pickupAddress',
          label: '提货地址',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'appointmentTime',
          label: '预约送货时间',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'customerName',
          label: '客户姓名',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'customerMobile',
          label: '客户手机',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'customerAddress',
          label: '客户地址',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'stockType',
          label: '出入库类型',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'stockSubType',
          label: '出入库子类',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'stockTime',
          label: '出入库时间',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'vendorComments',
          label: '商家备注',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'takerComments',
          label: '接单员备注',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'keeperComments',
          label: '库管备注',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'schedulerComments',
          label: '调度员备注',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'dutyPostId',
          label: '处理岗位ID',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'dutyUserId',
          label: '处理用户ID',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'carArranged',
          label: '已配车辆',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'status',
          label: '状态',
          render(h, m, v) {
            return <app-dict-display value={v} />;
          },
        },
        {
          name: 'createBy',
          label: '创建人',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'createTime',
          label: '创建时间',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'updateBy',
          label: '更新人',
          render(h, m, v) {
            return v || '--';
          },
        },
        {
          name: 'updateTime',
          label: '更新时间',
          render(h, m, v) {
            return v || '--';
          },
        },
      ],
      tableColumns: [
        { uid: 'name', dataIndex: 'name', title: '品牌名称', width: '200px' },
      ],
      //
      loading: false,
      model: {},
      rules: {},
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    id() {
      const id = this.$route.params.id;
      return id;
    },
  },
  created() {
    this.loadModel();
  },
  methods: {
    loadModel() {
      this.loading = true;
      this.$restful(`GET:/prj/orders/${this.id}`)
        .then((res) => {
          this.model = res || {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      this.$back();
    },
  },
};
</script>
<style lang="less" scoped>
.detail-container {
  height: 100%;
  padding: 20px;
  overflow: auto;
  .detail-content {
    height: 100%;
    background-color: #fff;
    overflow: auto;
  }
}

.title {
  padding: 2px 12px;
  border-left: 4px solid #1890ff;
  margin: 12px 0 12px -8px;
}
</style>

<style lang="less">
.vender_detail_container {
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
